import { SmartComposeInteraction } from '@qas/smartcompose-tslibrary/dist/src/smartComposeInteraction';
import { getGuid } from 'owa-guid';

export default function updateTelemetryForSuggestionOnSuggestionReturned(
    suggestionTelemetry: SmartComposeInteraction,
    suggestionTraceId: string,
    serviceLatency: number,
    suggestionReturned: boolean,
    suggestion: string,
    suggestionSource: string,
    sessionId: string
) {
    const now = new Date();
    suggestionTelemetry.suggestionTraceId = suggestionTraceId || getGuid();
    suggestionTelemetry.serviceLatency = serviceLatency;
    suggestionTelemetry.totalResponseLatency =
        now.getTime() - suggestionTelemetry.suggestionRequestTime.getTime();
    suggestionTelemetry.suggestionReturned = suggestionReturned;

    if (sessionId) {
        suggestionTelemetry.sessionId = sessionId;
    }

    if (suggestion) {
        suggestionTelemetry.suggestion = suggestion;
        suggestionTelemetry.suggestionLength = suggestion.length;
        suggestionTelemetry.suggestionSource = suggestionSource;
        suggestionTelemetry.suggestionReturned = true;
    }
}
